import { useLocalization } from '@components/Localization'
import { Box, breakpoints, Button, Text } from '@gassan-ui'
import { Article_article } from '@graphql/__generated__/Article'
import React, { FC } from 'react'
import styled from 'styled-components'
import AddToCart from '../AddToCart'
import Notice from './Notice'
import { getProductInformationProps } from './utils'

const ButtonGrid = styled(Box)`
  grid-column-gap: 1.5rem;
  grid-row-gap: 0.75rem;
  margin-top: 0.5rem;
  display: grid;
  @media screen and (min-width: ${breakpoints.small}) {
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 1;
    margin-top: 1rem;
  }
  @media screen and (min-width: ${breakpoints.large}) {
    grid-template-columns: 1fr;
    margin-top: 1.25rem;
  }

  button {
    width: 100%;
  }
`

type Props = Article_article & {
  handleMakeAppointment: () => void
  handleAskQuestion: () => void
}

const Buttons: FC<Props> = ({ handleMakeAppointment, handleAskQuestion, ...rest }) => {
  const { lang, messages } = useLocalization()
  const { buttons, title, label, usps } = getProductInformationProps(rest, lang)
  const isJewel = rest.articleAttributes.find(type => type.attributeID === 15)
  const isRing = isJewel ? isJewel.attributeValueID === 1 : false

  return (
    <>
      {title && label && <Notice title={title} label={label}></Notice>}
      <ButtonGrid>
        {buttons.map((type, index) => {
          if (type === 'order') {
            return (
              <AddToCart variant={isRing ? 'ring' : 'regular'} key={type} articleId={rest.id} />
            )
          }
          if (type === 'appointment') {
            return (
              <Button
                key={type}
                variant={index === 0 ? 'dark' : 'outline'}
                onClick={handleMakeAppointment}
              >
                {messages.productDetail.makeAppointment}
              </Button>
            )
          }
          if (type === 'question') {
            return (
              <Button
                key={type}
                variant={index === 0 ? 'dark' : 'outline'}
                onClick={handleAskQuestion}
              >
                {messages.productDetail.askAQuestion}
              </Button>
            )
          }
          return null
        })}
      </ButtonGrid>
      <Text mb="0" mt="1.5rem" ml="-0.5rem" as="div">
        <ul>
          {usps.map((usp, index) => (
            <li key={`usp_${index}`}>{usp}</li>
          ))}
        </ul>
      </Text>
    </>
  )
}

export default Buttons
